module.exports = __webpack_public_path__ + "static/media/34.9c6adcb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/34.jpg
// module id = 209
// module chunks = 0